import PortfolioOnboardingNotCompletedContainer from "./PortfolioOnboardingNotCompletedContainer";
import PortfolioOnboardingNotCompletedStore from "./PortfolioOnboardingNotCompletedStore";

export default PortfolioOnboardingNotCompletedStore(PortfolioOnboardingNotCompletedContainer);